import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useIntl } from 'react-intl';

const API_URL_REAL = process.env.REACT_APP_API_URL;

interface PlacementResult {
    code: string;
    program: string;
    obysStudentNumber: string;
    obysPassword: string;
    preferencePeriodName: string;
    message: string;
    name: string;
}

const PlacementPage = (): React.ReactElement | null => {
    const [placementResult, setPlacementResult] = useState<PlacementResult | null>(null);
    const [loading, setLoading] = useState(true);

    const intl = useIntl();

    useEffect(() => {

        axios.get<PlacementResult>(`${API_URL_REAL}/Custom/GetPlacementResult`)
            .then(response => {
                setPlacementResult(response.data);
                setLoading(false);
            })
            .catch(error => {

                setLoading(false);
            });
    }, []);

    if (loading) {
        return <p>Loading...</p>;
    }

    if (placementResult?.code === "0" || placementResult?.code === "2") {
        return <div className="alert alert-danger">{intl.formatMessage({ id: placementResult?.message })}</div>
    }

    if (!placementResult) {
        return <div className="alert alert-danger">{intl.formatMessage({ id: 'There is a problem with your request. Please try again later.' })}</div>
    }

    return (
        <div>
            <h1>{intl.formatMessage({ id: 'Dear' })} {placementResult.name}</h1>
            <h2>{intl.formatMessage({ id: 'Placement Results for' })}: {placementResult.preferencePeriodName}</h2>

            <div className="card mb-3">
                <div className="card-body">
                    <h5 className="card-title">{intl.formatMessage({ id: 'You have been placed in the program' })}: {placementResult.program}</h5>
                    <p className="card-text">
                        <strong>{intl.formatMessage({ id: 'OBYS Student Number' })}:</strong> {placementResult.obysStudentNumber}
                    </p>
                    <p className="card-text">
                        <strong>{intl.formatMessage({ id: 'OBYS Password' })}:</strong> {placementResult.obysPassword}
                    </p>
                </div>
            </div>

            <div className="alert alert-info">
                {intl.formatMessage({ id: 'Note' })}: {intl.formatMessage({ id: 'Use the OBYS Student Number and OBYS Password provided above for your initial registration.' })}
            </div>
        </div>
    );
};

export default PlacementPage;
